import type React from 'react';

import { Avatar, Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

export const StaffAvatar: React.FC = () => {
	return (
		<>
			<div className="flex flex-row items-center justify-center">
				<Avatar
					insetBorder
					alt="avatar"
					size={80}
					src="https://assets.change.org/photos/5/rm/sw/fqRMSWIetwCbMdr-400x400-noPad.jpg"
				/>
			</div>
			<Text variant="body" size="small" as="p" className="text-typography-strong mb-4">
				<TranslateHtml value="corgi.petition_actions.invite.expert_attribution" />
			</Text>
		</>
	);
};
